import { render, staticRenderFns } from "./SecurityCodeRules.vue?vue&type=template&id=23c3aa70&lang=pug&"
import script from "./SecurityCodeRules.vue?vue&type=script&lang=js&"
export * from "./SecurityCodeRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports